import { useTranslation } from '@wix/form-fields';
import React from 'react';
export const StepTitleA11y = _ref => {
  let {
    index = 0,
    total = 0
  } = _ref;
  const {
    t
  } = useTranslation();
  const stepTitleA11y = t('form.a11y.step.index.title', {
    index: index + 1,
    total
  });
  return total > 1 ? /*#__PURE__*/React.createElement("span", {
    "aria-label": stepTitleA11y,
    "aria-live": "polite"
  }) : null;
};
//# sourceMappingURL=step-title-a11y.js.map